export * from 'stores/search-base/mutation-types';
export const UPDATE_RESULT_ROW = 'UPDATE_RESULT_ROW';
